export class LoadingScreen {
  constructor(private readonly el: HTMLElement) {}

  setMessage(text: string): void {
    const label = this.el.querySelector('.loading-label');
    if (label !== null) label.textContent = text;
  }

  hide(): void {
    this.el.classList.add('done');
    window.setTimeout(() => this.el.remove(), 400);
  }
}
